// extracted by mini-css-extract-plugin
export default {"button":"ButtonNeutral_button__Bhkml"};